import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {isOk} from '../../utils/apiResponse';
import {UI_VERSION_V2, useUiVersion} from '../../context/UserModulesContext';
import {fetchAgencyRules} from './ga4AttributionApi';
import {AGENCY_CARD_URL, agencyRulesFromPayload} from './attributionModel';

/**
 * La regla de cruce con GA4 en Conexiones del clásico: una línea que dice que se configura en la 2.1
 * (patrón `AlertRulesNote` del Centro de Alertas). La tarjeta existe sólo en la 2.1.
 *
 * Aparece sólo si el backend tiene la regla (el GET responde con reglas): con el backend viejo, o si
 * el pedido falla, no dice nada. El link pasa a la 2.1 y aterriza en la tarjeta: un `?ui=v2` en la URL
 * no cambia de marco en una navegación sin recarga.
 */
export function Ga4AttributionClassicNote() {
    const {t} = useTranslation();
    const {setUiVersion} = useUiVersion();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let cancelled = false;
        fetchAgencyRules().then((response) => {
            if (cancelled || !isOk(response) || !response.data) return;
            setVisible(agencyRulesFromPayload(response.data).rules.length > 0);
        });
        return () => { cancelled = true; };
    }, []);

    if (!visible) return null;
    return (
        <div className="section-body h-items" style={{paddingBottom: '0em'}}>
            <div className="alert alert-info" data-testid="ga4-attr-classic-note">
                <Link to={AGENCY_CARD_URL} onClick={() => setUiVersion(UI_VERSION_V2)}>
                    {t('ga4_attribution.agency.classic_note')}
                </Link>
            </div>
        </div>
    );
}

export default Ga4AttributionClassicNote;
